import { track } from '@cartwheel/analytics'
import type { Task } from '@cartwheel/api/v1'
import type { CostEstimateInteraction } from '../cost-estimate/types'

export type TaskDrawerCloseReason = 'action_completed' | 'user_closed'

export type TaskResourceDestination =
  | 'apero'
  | 'availity'
  | 'cartwheel'
  | 'case_assignment'
  | 'healthie'
  | 'kustomer'

export function taskAnalyticsContext(task: Task) {
  return {
    taskId: task.id,
    taskType: task.type,
    taskStatus: task.status,
    workflowType: task.workflow?.type ?? null,
  }
}

export function trackTaskDrawerOpened(task: Task) {
  track('TASK_DRAWER_OPENED', taskAnalyticsContext(task))
}

export function trackTaskDrawerClosed(task: Task, reason: TaskDrawerCloseReason) {
  track('TASK_DRAWER_CLOSED', { ...taskAnalyticsContext(task), reason })
}

export function trackTaskResourceLink(task: Task, destination: TaskResourceDestination) {
  track('TASK_RESOURCE_LINK_CLICKED', {
    taskId: task.id,
    taskType: task.type,
    destination,
  })
}

export function trackTaskCostEstimateInteraction(task: Task, interaction: CostEstimateInteraction) {
  const context = { ...taskAnalyticsContext(task), context: 'task_drawer' }

  switch (interaction.type) {
    case 'editor_opened':
      track('COST_ESTIMATE_EDITOR_OPENED', { ...context, mode: interaction.mode })
      break
    case 'type_selected':
      track('COST_ESTIMATE_TYPE_SELECTED', {
        ...context,
        estimateType: interaction.estimateType,
      })
      break
    case 'sync_requested':
      track('COST_ESTIMATE_SYNC_REQUESTED', { ...context, mode: interaction.mode })
      break
    case 'editor_canceled':
      track('COST_ESTIMATE_EDITOR_CANCELED', {
        ...context,
        mode: interaction.mode,
        estimateType: interaction.estimateType,
      })
      break
    case 'save_submitted':
      track('COST_ESTIMATE_SAVE_SUBMITTED', {
        ...context,
        mode: interaction.mode,
        estimateType: interaction.estimateType,
      })
      break
  }
}
